import type { ReactNode } from "react";
import { cn } from "../../lib/utils";

export interface DataTableColumn<T> {
  key: string;
  label: string;
  /** Piso da coluna, ex. "minmax(5rem,2fr)" ou "3.25rem" — nunca fr puro. */
  width: string;
  mono?: boolean;
  render: (row: T) => ReactNode;
}

export interface DataTableProps<T> {
  columns: DataTableColumn<T>[];
  rows: T[];
  rowKey: (row: T) => string | number;
  renderCard: (row: T) => ReactNode;
  emptyState?: ReactNode;
}

/**
 * Substitui as 6 tabelas de admin (handoff, R5/regra 2: "toda coluna de
 * grade tem PISO; sem piso a celula colapsa"). Abaixo de 48rem (Tailwind
 * `md`, que e exatamente 48rem) vira lista de `.row-card` via renderCard —
 * nunca encolhe coluna.
 */
export function DataTable<T>({ columns, rows, rowKey, renderCard, emptyState }: DataTableProps<T>): JSX.Element {
  if (rows.length === 0 && emptyState) {
    return <>{emptyState}</>;
  }

  const template = columns.map((c) => c.width).join(" ");

  return (
    <div className="card" style={{ padding: 0 }}>
      {/* Desktop: grade com piso em cada coluna */}
      <div className="hidden md:block">
        <div className="row row__head" style={{ gridTemplateColumns: template, padding: "0 1rem" }}>
          {columns.map((c) => (
            <span key={c.key} className="row__cell">{c.label}</span>
          ))}
        </div>
        {rows.map((row) => (
          <div
            key={rowKey(row)}
            className="row"
            style={{ gridTemplateColumns: template, padding: "0 1rem" }}
          >
            {columns.map((c) => (
              <span key={c.key} className={cn("row__cell", c.mono && "mono")}>
                {c.render(row)}
              </span>
            ))}
          </div>
        ))}
      </div>

      {/* Mobile: lista de cartoes, nunca coluna encolhida.
          Medido ao vivo (getComputedStyle): combinar a classe de display
          responsivo do Tailwind (`md:hidden`) com `.stack` no MESMO
          elemento faz `.stack{display:flex}` vencer em qualquer largura
          — reproduzido em /admin/tags e /admin/usuarios (onda W2). A causa
          nao e especificidade nem ordem de @layer (testado isolado: o
          resultado contraria a ordem teorica components<utilities do
          proprio Tailwind, provavelmente por como o plugin Vite emite o
          layer de utilities desta versao). Fix robusto independente desse
          detalhe de build: NUNCA por as duas classes no mesmo elemento —
          o wrapper externo so tem a classe do Tailwind (`md:hidden`, sem
          concorrente), o `.stack` fica isolado num filho. */}
      <div className="md:hidden">
        <div className="stack" style={{ padding: ".75rem" }}>
          {rows.map((row) => (
            <div key={rowKey(row)}>{renderCard(row)}</div>
          ))}
        </div>
      </div>
    </div>
  );
}
